import { Deserializable } from '../protocols/deserializable';

export class NameChangeSubmission implements Deserializable {
  public previous!: NameChangeSubmissionInfo;
  public new!: NameChangeSubmissionInfo;

  onDeserialize(): void {
    const Deserialize = window?.injector?.Deserialize;

    if (!!this.previous) {
      this.previous = Deserialize?.instanceOf(NameChangeSubmissionInfo, this.previous);
    }

    if (!!this.new) {
      this.new = Deserialize?.instanceOf(NameChangeSubmissionInfo, this.new);
    }
  }
}

export class NameChangeSubmissionInfo implements Deserializable {
  public firstName!: string;
  public lastName!: string;
  public middleName!: string;
  public preferredName!: string;

  onDeserialize(): void {}
}
